import { RetryConfig } from "../types";

export const resetRetryCount = (
  retryCountRef: React.MutableRefObject<number>
): void => {
  retryCountRef.current = 0;
};

export const createRetryFunction = <T>(
  fn: () => Promise<T>,
  config: RetryConfig
): Promise<T> => {
  const { maxRetries, retryCountRef } = config;
  return new Promise(
    // eslint-disable-next-line no-async-promise-executor
    async (resolve: (value: T) => void, reject: (reason?: unknown) => void) => {
      let lastError: unknown;

      for (let i = 0; i <= maxRetries; i++) {
        try {
          const result = await fn();
          resetRetryCount(retryCountRef);
          resolve(result);
          return; // Exit loop on success
        } catch (error) {
          lastError = error;
          retryCountRef.current = i + 1;
        }
      }

      resetRetryCount(retryCountRef);
      reject(lastError);
    }
  );
};
